import React from 'react';
import * as Styled from './style';

interface Props {
  data: {
    allowScheduling: string;
    billingDescription: string;
    paymentPlans: string;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  errors: {
    allowScheduling?: string;
    billingDescription?: string;
    paymentPlans?: string;
  };

  setErrors: React.Dispatch<React.SetStateAction<any>>;
     handleChange: (
       e:
         | React.ChangeEvent<HTMLInputElement>
         | React.ChangeEvent<HTMLTextAreaElement>
         | React.ChangeEvent<HTMLSelectElement>
     ) => void;
     handleBlur: (
       e:
         | React.ChangeEvent<HTMLInputElement>
         | React.ChangeEvent<HTMLTextAreaElement>
         | React.ChangeEvent<HTMLSelectElement>
     ) => void;

  handleNext: () => void;
  handleBack: () => void;
}

export default function StepFive({
  data,
  setFormData,
  errors,
  handleChange,
  handleNext,
  handleBack,
}: Props) {
  return (
    <>
      <Styled.Title>Payment & Consultation Info</Styled.Title>

      <Styled.Group>
        <Styled.Label>
          Would you like the AI chatbot to attempt to book a time with new clients on your calendar?
        </Styled.Label>

        <Styled.RadioGroup>
          <label>
            <input
              type="radio"
              name="allowScheduling"
              value="Yes"
              checked={data.allowScheduling === 'Yes'}
              onChange={handleChange}
            />
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="allowScheduling"
              value="No"
              checked={data.allowScheduling === 'No'}
              onChange={handleChange}
            />
            No
          </label>
        </Styled.RadioGroup>

        {errors.allowScheduling && <Styled.Error>{errors.allowScheduling}</Styled.Error>}
      </Styled.Group>

      <Styled.Group>
        <Styled.Label>
          Briefly describe your billing process. How are clients billed for services? (Optional)
        </Styled.Label>
        <Styled.Textarea
          name="billingDescription"
          value={data.billingDescription}
          onChange={handleChange}
        />
        {errors.billingDescription && <Styled.Error>{errors.billingDescription}</Styled.Error>}
      </Styled.Group>

      <Styled.Group>
        <Styled.Label>
          Do you offer payment plans? If so, explain the terms and how clients qualify. (Optional)
        </Styled.Label>
        <Styled.Textarea
          name="paymentPlans"
          value={data.paymentPlans}
          onChange={handleChange}
        />
        {errors.paymentPlans && <Styled.Error>{errors.paymentPlans}</Styled.Error>}
      </Styled.Group>

      <Styled.ButtonGroup>
        <Styled.Button type="button" onClick={handleBack}>Go back</Styled.Button>
        <Styled.Button type="button" onClick={handleNext}>
          Next step: common questions →
        </Styled.Button>
      </Styled.ButtonGroup>
    </>
  );
}
